export const SHARED_FILES_DRAG_MIME = 'application/x-workloop-shared-attachment';
export const SHARED_FILES_ROOT_DROP = '__root__';
export const SHARED_FILES_NEW_GROUP_DROP = '__new_group__';
export const SHARED_ITEM_LINK = 'link';
export const SHARED_ITEM_ATTACHMENT = 'attachment';

export function isNewGroupDropTarget(drop) {
  return drop?.messageId === SHARED_FILES_NEW_GROUP_DROP;
}

export function isLinkDragPayload(payload) {
  return payload?.itemType === SHARED_ITEM_LINK;
}

export function resolveAttachmentId(attachmentOrId) {
  if (attachmentOrId == null) return null;
  if (typeof attachmentOrId === 'string') return attachmentOrId;
  return attachmentOrId.id || attachmentOrId._id || null;
}

/** Attachment id from a shared-files drag payload ({ sourceMessageId, attachmentId }). */
export function resolvePayloadAttachmentId(payload) {
  if (!payload) return null;
  return resolveAttachmentId(payload.attachmentId) || payload.attachmentId || null;
}

export function createLinkDragPayload(sourceMessageId) {
  return { itemType: SHARED_ITEM_LINK, sourceMessageId };
}

export function createAttachmentDragPayload(sourceMessageId, attachmentOrFile) {
  const attachmentId = typeof attachmentOrFile === 'object'
    ? (resolveAttachmentId(attachmentOrFile) || attachmentOrFile?.id || attachmentOrFile?._id)
    : attachmentOrFile;
  const fileUrl = typeof attachmentOrFile === 'object'
    ? (attachmentOrFile?.fileUrl || null)
    : null;
  return {
    itemType: SHARED_ITEM_ATTACHMENT,
    sourceMessageId,
    attachmentId,
    fileUrl,
  };
}

export function buildMoveRequestBody(payload, insertIndex = null) {
  const body = {
    sourceMessageId: payload.sourceMessageId,
    itemType: isLinkDragPayload(payload) ? SHARED_ITEM_LINK : SHARED_ITEM_ATTACHMENT,
  };
  if (!isLinkDragPayload(payload)) {
    body.attachmentId = resolvePayloadAttachmentId(payload);
    if (payload?.fileUrl) {
      body.fileUrl = payload.fileUrl;
    }
  }
  if (insertIndex != null) {
    body.insertIndex = insertIndex;
  }
  return body;
}

export function setSharedAttachmentDragData(e, payload) {
  const normalized = {
    itemType: payload?.itemType || SHARED_ITEM_ATTACHMENT,
    sourceMessageId: payload?.sourceMessageId,
    attachmentId: resolvePayloadAttachmentId(payload) || payload?.attachmentId,
    fileUrl: payload?.fileUrl || null,
  };
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData(SHARED_FILES_DRAG_MIME, JSON.stringify(normalized));
  e.dataTransfer.setData(
    'text/plain',
    isLinkDragPayload(normalized) ? 'link' : (normalized.attachmentId || '')
  );
}

export function readSharedAttachmentDragData(e) {
  const raw = e.dataTransfer.getData(SHARED_FILES_DRAG_MIME);
  if (!raw) return null;
  try {
    const payload = JSON.parse(raw);
    if (payload && !payload.itemType) {
      payload.itemType = SHARED_ITEM_ATTACHMENT;
    }
    if (payload && !payload.attachmentId && payload.itemType !== SHARED_ITEM_LINK) {
      payload.attachmentId = resolvePayloadAttachmentId(payload);
    }
    return payload;
  } catch {
    return null;
  }
}

export function isSharedAttachmentDrag(e) {
  return Array.from(e.dataTransfer?.types || []).includes(SHARED_FILES_DRAG_MIME);
}

export function isRootDropTarget(drop) {
  return drop?.messageId === SHARED_FILES_ROOT_DROP;
}

export const SHARED_DRAG_GRIP_SELECTOR = '[data-shared-drag-grip]';

export function isOverSharedDragGrip(event) {
  return Boolean(event?.target?.closest?.(SHARED_DRAG_GRIP_SELECTOR));
}
